import "@/App.css";
import { ReactLenis } from "lenis/react";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import BrandMarquee from "./components/site/BrandMarquee";
import Quidory from "./components/site/Quidory";
import Media from "./components/site/Media";
import Services from "./components/site/Services";
import House from "./components/site/House";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.085, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="App relative bg-ink text-cloud font-body" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <BrandMarquee />
          <Quidory />
          <Media />
          <Services />
          <House />
          <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
